// Fields the System Identification form actually asks the user to fill in.
// Everything else on the component (select-box open/closed flags, temporary
// green-circle feedback) is transient UI state and must not count as an edit.
const TRACKED_FIELDS = [
  'locationName',
  'specificLocation',
  'civicAddress',
  'numOfUOS',
  'numOfSSR',
  'numSwitches',
  'switches',
];

// Serialise now, compare later. A string comparison avoids holding a reference
// to the live switches array, which the form mutates in place in several spots.
export const snapshotSysIdForm = (form) =>
  JSON.stringify(TRACKED_FIELDS.map((field) => form?.[field] ?? null));

export const isSysIdFormDirty = (snapshot, form) => {
  if (!snapshot) return false;
  return snapshot !== snapshotSysIdForm(form);
};
